import YouTubePlayer from 'youtube-player';
import EmbeddedConcentElement from '../EmbeddedConcentElement/EmbeddedConcentElement';

class IframeYoutube extends EmbeddedConcentElement {
  // constructor done by parent class
  //  constructor() { }

  initElement(){

    const iframeContainer = document.createElement('div');
    iframeContainer.setAttribute('class', 'iframe-container');

    this.appendChild(iframeContainer);

    this.videoId = this.getAttribute('video-id')
    this.videoKey = this.getAttribute('video-key')
    this.defaultCover = this.getAttribute('default-cover')
    this.posterUrl = 'https://img.youtube.com/vi/' + this.videoId + '/maxresdefault.jpg'

    this.posterMarkup = `<figure class="iframe__poster figure-gradient">
      <img 
        src="${this.posterUrl}" 
        width="1280"
        height="720" 
        alt="Poster" 
        class="iframe__img"
        loading="lazy">
      <button
        class="button iframe__play"
        type="button"
        value="Play Video"
      >
      <svg class="icon icon-play" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      <path d="M0 5C0 2.23858 2.23858 0 5 0H35C37.7614 0 40 2.23858 40 5V35C40 37.7614 37.7614 40 35 40H5C2.23858 40 0 37.7614 0 35V5Z" fill="currentColor"/>
      <path d="M13 13.8777C13 12.4507 14.529 11.5477 15.779 12.2347L27.319 18.5817C28.614 19.2937 28.614 21.1547 27.319 21.8677L15.78 28.2147C14.53 28.9017 13.001 27.9977 13.001 26.5717L13 13.8777Z" fill="black"/>
      </svg>
        <span class="visually-hidden">Play Vimeo Video</span>
      </button>
    </figure>`;

    // Create a shadow root
    //const shadow = this.attachShadow({mode: 'open'});

 

    // Create player element
    const wrapper = document.createElement('div');
    wrapper.setAttribute('id', `player-${this.videoKey}`);
    iframeContainer.appendChild(wrapper);

    iframeContainer.insertAdjacentHTML("beforeend", this.posterMarkup)


   

    this.player = YouTubePlayer(`player-${this.videoKey}`, {
      videoId: this.videoId
    });

    this.playButton = this.querySelector(".iframe__play")
    this.poster = this.querySelector(".iframe__poster")

    this.playButton.addEventListener("click", evt => {
      evt.preventDefault()
      this.poster.classList.add("iframe__poster--playing")
      this.player.playVideo()
    })

    this.player.on('stateChange', (evt) => {
      if (evt.data === 0) {
        this.poster.classList.remove("iframe__poster--playing")
      }
    })


    this.calculateSize(this.posterUrl)
      .then(data => {
        if (data.width === 120 && data.height === 90) {
          iframeContainer.querySelector(".iframe__img").src = this.defaultCover
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  calculateSize(url) {
    return new Promise(function(resolve, reject) {
      const image = document.createElement('img');
      image.addEventListener('load', function(e) {
        resolve({
          width: e.target.width,
          height: e.target.height,
        });
      });

      image.addEventListener('error', function() {
        reject('error');
      });

      image.src = url;
    });
  }
}

export default IframeYoutube
